
export default {
    SET: (state, obj) => {
        state[obj.key] = obj.value;
    },
}